export enum EImportacaoType {
  CARGA = 'CARGA',
  ATIVACAO = 'ATIVACAO',
  FUNCIONARIO = 'FUNCIONARIO'
}
